import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { Textarea } from "../../primitives/textarea";
/**
 * Wraps textarea in a property line
 * @param props - PropertyLineProps and TextProps
 * @returns property-line wrapped text
 */
export const TextAreaPropertyLine = (props) => {
    TextAreaPropertyLine.displayName = "TextAreaPropertyLine";
    return (_jsx(PropertyLine, { ...props, children: _jsx(Textarea, { ...props }) }));
};
//# sourceMappingURL=textAreaPropertyLine.js.map